import { setAlpha } from '../../design-tokens';
import { renderDesignTokens } from '../../theme';

// DND Style Tokens
// ref: http://designsystem-snapshot.sas.com/latest/components/drag-and-drop/styling/

/**
 * @deprecated
 * Use `getDndDesignTokens` instead.
 */
export const getDndStyleTokens = dt => {
  return getDndDesignTokens(dt);
};
export const getDndDesignTokens = dt => {
  return {
    ...renderDesignTokens({
      'item-medium-sh': dt.tokens['shadow-depth-m'],
      'drag-image-bg': dt.tokens['color-container-background-0'],
      'copied-item': dt.tokens['color-secondary'],
      'drop-line-bg': dt.tokens['color-primary'],
      'drop-line-loop': dt.tokens['color-text-neutral-inverse'],
      'drop-line-loop-shadow': setAlpha(dt.tokens['color-primary'], 0.8),
      'drop-zone-bd': dt.tokens['color-primary'],
      'drop-zone-bg': setAlpha(dt.tokens['color-primary'], 0.1),
      'item-trans-dur': dt.tokens['duration-500'],
      'item-anim-dur': dt.tokens['duration-300'],
      'moved-item-opacity': 0.3,
      'drag-image-border-color': dt.tokens['color-container-background-4'],
      'drag-image-border-width': dt.tokens['size-border-width-s'],
      'drag-image-border-radius': dt.tokens['size-border-radius-xs'],
      'drag-image-spacing-xs': dt.tokens['space-base-xs'],
      'drag-image-before-position-top': '0.25rem',
      'drag-image-before-position-left': '0.25rem',
      'drag-image-after-position-top': '0.5rem',
      'drag-image-after-position-left': '0.5rem'
    }, 'dnd'),
    ...(!dt.enableNovaTokens && getDndLegacyDesignTokens(dt))
  };
};
export const getDndLegacyDesignTokens = dt => {
  return renderDesignTokens({
    'item-medium-sh': dt.reportTokens.backgroundsDepth.medium.sh,
    'drag-image-bg': dt.reportTokens.backgroundsDepth.standard.bg,
    'copied-item': dt.c.secondary,
    'drop-line-bg': dt.c.primary,
    'drop-line-loop': dt.c.white,
    'drop-line-loop-shadow': setAlpha(dt.c.primary, 0.8),
    'drop-zone-bd': dt.c.primary,
    'drop-zone-bg': setAlpha(dt.c.primary, 0.1)
  }, 'dnd');
};
//# sourceMappingURL=DndStyleTokens.js.map